// extracted by css-extract-rspack-plugin
export default {"environment":"mlO5_TgqKtQI7Eld","color":"qrvi0okmrE0j_mso","display":"lJRZk7X9O2wNnhYk"};